import React from 'react';
import { HiMail } from "react-icons/hi";
import { IoLogoGithub } from "react-icons/io";
import { SiSpigotmc } from "react-icons/si";
import { FaSquareXTwitter } from "react-icons/fa6";

const SocialLink = ({ href, icon: Icon, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="mc-btn flex items-center gap-2"
  >
    <Icon className="text-xl" />
    {label && (
      <span className="text-md font-bold uppercase tracking-wider">
        {label}
      </span>
    )}
  </a>
);

const Footer = () => {
  return (
    <footer
      id="contact"
      className="relative mt-32 border-t-4 border-black bg-[#1e1e1e] py-12 select-none"
    >
      <div className="mx-auto max-w-6xl px-4 relative z-10">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
          {/* Logo Section */}
          <div className="flex flex-col items-center justify-center md:items-start">
            <span>
              <h2 className="font-impact text-xl tracking-wider text-white uppercase font-extrabold">
                <span className="text-[#55ff55]">I</span>am
                <span className="text-[#55ff55]">T</span>he
                <span className="text-[#55ff55]">D</span>efender
              </h2>
            </span>
          </div>

          {/* Social Links as Minecraft buttons */}
          <div className="flex flex-col items-center gap-4 md:items-end">
            <div className="flex items-center gap-3">
              <SocialLink
                href="https://github.com/IamTheDefender"
                icon={IoLogoGithub}
              />
              <SocialLink
                href="https://twitter.com/iamthedefender_"
                icon={FaSquareXTwitter}
              />
              <SocialLink
                href="https://www.spigotmc.org/members/kepler121.1531997/"
                icon={SiSpigotmc}
              />
            </div>
            
            <div>
              <SocialLink
                href="mailto:contact@iamthedefender.xyz"
                icon={HiMail}
                label="contact@iamthedefender.xyz"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;